// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3i9yf","boxTitle":"Qualiphy_boxTitle__3P4vv","box":"Qualiphy_box__3WNY1","toggleWrap":"Qualiphy_toggleWrap__3mipG"};